import React, { Component } from 'react';

class SelectRecordModal extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            selectedKey: ""
        };
    }

    onSelectRecord = (uniqueKey) => {
        // console.log(uniqueKey)
        this.setState({ selectedKey: uniqueKey})
    }
    selectedRecord = () => {
        if (this.props.selectedRecord) {
            this.props.selectedRecord(this.state.selectedKey);
          }
    }
    render() {
        const data = this.props.data
        // console.log(data)
        // let result = [];
        // if(data !== undefined) {
        //     result = Object.keys(data).map(function(key) {
        //         console.log(data[key])
        //         return [data[key]];
        //     });
        //     console.log(result)
        // }
        return (
            <div
                className="modal fade"
                id="selectRecord"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="selectRecordTitle"
                aria-hidden="true"
            >
                <div className="modal-dialog ">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5
                                className="modal-title text-center fontLarge"
                                id="selectRecordTitle"
                            >
                                Create New Record
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body fontMedium text-justify">
                            <p className="text-center">
                                We have located multiple businesses given the criteria provided.<br/>
                                Please choose from one of the results below.
                            </p>
                            <div>
                                {
                                    data.map((item, index) => {
                                        // console.log(index)
                                        // console.log(item)
                                        return(
                                            <div key={index} className={this.state.selectedKey === item.uniqueKey ? "card bg-success text-white" : "card"} style={{marginBottom: 8}} onClick={() => this.onSelectRecord(item.uniqueKey)}>
                                                <div className="card-body record" >
                                                    <li><b>{item.contact.nameLast}</b></li>
                                                    <li>{item.serviceAddress.address}</li>
                                                    <li>{item.serviceAddress.city}, {item.serviceAddress.state} {item.serviceAddress.zip}</li>
                                                    {/* <button className="btn btn-secondary" style={{float: "right"}}>SELECT</button> */}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="">
                                <button
                                    type="button"
                                    className="disagreeButton"
                                    data-dismiss="modal"
                                    style={{ marginRight: "10px", marginBottom: "10px" }}
                                >
                                    CANCEL
                                </button>
                                <button
                                    type="button"
                                    className="button"
                                    style={{ marginBottom: "10px" }}
                                    onClick={this.selectedRecord}
                                    // data-dismiss="modal"
                                >
                                    NEXT
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
        );
    }
}

export default SelectRecordModal;


// WEBPACK FOOTER //
// ./src/views/Modal/selectRecordModal.jsx